import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

// 清缓存
const VUE_APP_VERSION = require('../package.json').version
const vers = localStorage.getItem('v-version')
if (VUE_APP_VERSION !== vers) {
  localStorage.clear()
  localStorage.setItem('v-version', VUE_APP_VERSION)
  location.reload()
// } else {
//   const swvers = window.localStorage.getItem('sw-version')
//   if (VUE_APP_VERSION !== swvers) {
//     window.localStorage.setItem('sw-version', VUE_APP_VERSION)
//     ServiceWorkerRegister()
//   }
}
console.log('v', vers)
// console.log('v', VUE_APP_VERSION)
